import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { report, ReportManipulationViewModel } from "./reportManipulation-viewModel"

export class ReportManipulationView extends View<ReportManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-9DE989EC-A5D8-4FC1-989A-7E4D27840AC0"
    }
    loadHtml(): string {
        let element = require('./reportManipulation.html').default;
        let style = require('./reportManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set reports(v: ObservableArray<report>) { this._reports = v; } public get reports(): ObservableArray<report> { return this._reports;} private _reports: ObservableArray<report>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    addNew(){
        this.dataContext.addNew();
    }

}
